import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img3 from "../../About/images/3.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person3 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img3} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Кучанский Александр
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        M.Sc., PhD, Dr.Sc., профессор департамента вычислений и науки о данных
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57190488151'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-1277-8031'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", профессор департамента вычислений и науки о данных
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Проведение исследований и создание методов и моделей прогнозирования временных рядов выбросов загрязняющих веществ и выпусков сточных вод для задачи экологического мониторинга
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Доктор технических наук, профессор в области информационных технологий. Занимается математическим моделированием и анализом данных. Стаж по профилю — более 13 лет.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта грантового финансирования, (AP23490123) «Разработка системы идентификации текстовых заимствований на основе комбинированных методов и моделей поиска неполных дубликатов с учетом казахского языка» (2024 -2026 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта грантового финансирования, (AP19678730) «Разработка информационной технологии точного земледелия для управления сельскохозяйственной деятельностью с применением «Internet of Things» (2023-2025 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта грантового финансирования, (AP19678627) «Разработка информационной технологии, формирования мультиуниверситетских научных и образовательных сообществ, основанной на теории наукометрического анализа» (2023 -2025 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта грантового финансирования, (AP13067967) «Разработка технологии построения микропроцессорных ресурсосберегающих устройств релейной защиты на основе открытой архитектуры» (2022-2024 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта по программе "Программно-целевое финансирование по научным, научно-техническим программам" Комитета науки Министерства науки и высшего образования Республики Казахстан, (BR10965311) Разработка интеллектуальных информационно-телекоммуникационных систем для городской инфраструктуры: транспорт, экология, энергетика и аналитика данных в концепте Smart City (2021-2023 г.)
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Исполнитель проекта грантового финансирования, (AP08857218) «Информационная технология оценивания научной деятельности вузов, НИИ и их подразделений» (2020-2022 г.)
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проведение исследований и создание методов и моделей прогнозирования временных рядов выбросов загрязняющих веществ и выпусков сточных вод для задачи экологического мониторинга.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Biloshchytskyi A., Kuchanskyi O., Neftissov A., Andrashko Y., Biloshchytska S., Kazambayev, I. (2024). Fractal Analysis of Mining Wastewater Time Series Parameters. Urban Science. DOI: 10.3390/urbansci8040200 (SCOPUS, Q1)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Biloshchytskyi, A. et al. (2024). Fractal Analysis of Air Pollution Time Series in Urban Areas in Astana. Urban Science. DOI: 10.3390/urbansci8030131 (SCOPUS, Q1)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Neftissov, A. et al. (2023). Determination of the speed of a microprocessor relay protection device. Eastern-European Journal of Enterprise Technologies, 2 (9 (122)), 20–30. DOI: https://doi.org/10.15587/1729-4061.2023.276588 (SCOPUS, Q3)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    4. Biloshchytskyi, A. et al. (2022). Model for Choosing Strategy to Reduce Air Pollution. Eastern-European Journal of Enterprise Technologies, 3 (4-117), pp. 23–30. DOI: 10.15587/1729-4061.2022.259323 (SCOPUS, Q3)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    5. Biloshchytskyi A. et al. (2024). Integrated model for forecasting environmental pollution parameters. Scientific Journal of Astana IT University, Выпуск 19, pp. 163–178. DOI: 10.37943/20ASCK9705 (КОКСОН)
                </MyText>
            </Flex>
        </Flex>
    );
}